<template>
  <AppLoader>
    <img alt="Logo" src="/svg/logos/deepbox_logo.svg" width="180" />
  </AppLoader>
</template>

<script lang="ts" setup>
import AppLoader from '@/components/app/AppLoader.vue'
</script>
